import React from 'react';

import { Box, Typography } from '@mui/material';

interface Props {
  label: string;
  children: React.ReactNode;
}

/** One caption-over-value cell in the ticket detail dialog's grids. */
export default function DetailField({ label, children }: Props) {
  return (
    <Box>
      <Typography variant="caption" color="text.secondary">
        {label}
      </Typography>
      <Typography sx={{ overflowWrap: 'anywhere' }}>{children}</Typography>
    </Box>
  );
}
